import { Component } from '@angular/core';

@Component({
    selector: 'dashboard-organizer-skeleton',
    templateUrl: './dashboard-organizer-skeleton.component.html',
    styleUrl: './dashboard-organizer-skeleton.component.scss',
    standalone: false
})
export class DashboardOrganizerSkeletonComponent {

}
